module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-query"
  }, [_c('el-input', _vm._b({
    attrs: {
      "value": _vm.value,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": _vm.inputHander
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterHander.apply(null, arguments)
      }
    }
  }, 'el-input', _vm.$attrs, false), [_c('rt-icon', {
    staticClass: "rt-query-icon",
    attrs: {
      "slot": "suffix",
      "size": 28,
      "color": "#fff",
      "name": "rt-base-lookup"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSearch.apply(null, arguments)
      }
    },
    slot: "suffix"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d311448"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/search/rtQuery.vue
// module id = 1509
// module chunks = 124